import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {UspsLoading} from './UspsLoading';
import {UspsView} from './UspsView';
import {useGetBrowseUsps} from './useGetBrowseUsps';

export const Usps: React.FC<{className?: string}> = ({className}) => {
  return (
    <DataFetcher
      request={useGetBrowseUsps()}
      Error={null}
      Loading={UspsLoading}
      View={UspsView}
      viewProps={{className}}
    />
  );
};
